/**
 * Slider init.
 */
import 'slick-carousel';

$('.js-slider-product').slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: false,
	responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
    		dots: true,
    		dotsClass: 'slider__paging',
        adaptiveHeight: true,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
    		dots: true,
    		dotsClass: 'slider__paging',
        adaptiveHeight: true,
      }
    }
  ]
});

$('.js-slider-testimonials').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: true,
	dotsClass: 'slider__paging',
	prevArrow: '<button type="button" class="slider__prev"></button>',
	nextArrow: '<button type="button" class="slider__next"></button>',
	infinite: true,
	autoplay: true,
	autoplaySpeed: 3000
});

$('.js-slider-header').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	infinite: true,
	responsive: [
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
    		prevArrow: '<button type="button" class="slider__prev slider__prev--alt"></button>',
    		nextArrow: '<button type="button" class="slider__next slider__next--alt"></button>',
    		arrows: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: '<button type="button" class="slider__prev slider__prev--alt"></button>',
        nextArrow: '<button type="button" class="slider__next slider__next--alt"></button>',
        arrows: true
      }
    }
  ]
});

$('.js-product-media-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  prevArrow: '<button type="button" class="product__slider-arrow product__slider-arrow--left"></button>',
  nextArrow: '<button type="button" class="product__slider-arrow product__slider-arrow--right"></button>',
  infinite: false
});


if ($('.spr-reviews').length > 0) {
  const initReviewsSlider = () => {
    $('.spr-reviews').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true
  });
  }

  const reviews = document.getElementById('shopify-product-reviews');

  const config = { attributes: false, childList: true, subtree: false };

  const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === "childList") {
          const $reviews = $('.spr-reviews');

          if ($reviews.children().length && ! $reviews.hasClass('slick-initialized')) {
            initReviewsSlider();
          }
        }
      }
  };

  const observer = new MutationObserver(callback);

  observer.observe(reviews, config);
}
